import { useSelectAllAccounts } from 'selectors/selectors';
import { getAccountOptions } from 'utilities/account-utilities';
import { DropDownOption } from './types/CardModalFormNames';

/**
 * We can use this hook to get the default account and check if there are multiple accounts.
 * Handy for autofilling the form when there is only one account.
 */

export function useGetDefaultAccount() {
  const allAccounts = useSelectAllAccounts();
  const accountOptions = getAccountOptions(
    allAccounts,
    false
  ) as DropDownOption[];
  const hasMultipleAccounts = accountOptions.length > 1;
  const hasMultipleChildAccounts = Array.isArray(accountOptions?.[0]?.value);
  const hasMultiple = hasMultipleAccounts || hasMultipleChildAccounts;
  const defaultAccount = hasMultiple ? null : accountOptions[0]?.value;
  return {
    defaultAccount,
    hasMultiple,
    hasMultipleAccounts,
    hasMultipleChildAccounts,
  };
}
